import { Routes } from '@angular/router';
import { isValidEventGuard } from '@core/guards/is-valid-event.guard';
import { isBrandedCanMatch, isUnbrandedCanMatch } from '@core/guards/check-branded-domain.guard';

export const routes: Routes = [
  {
    // skip validation and only for render mfe account select
    path: 'auth',
    loadComponent: () =>
      import('@pages/account-selection/account-selection.component').then((c) => c.AccountSelectionComponent),
    loadChildren: () =>
      import('@pages/account-selection/account-selection.routes').then((c) => c.accountSelectionRoutes),
  },
  {
    path: 'not-found',
    data: {
      isNotFound: true,
    },
    loadComponent: () => import('@pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
  },
  {
    path: '',
    canMatch: [isBrandedCanMatch],
    canActivate: [isValidEventGuard],
    loadComponent: () => import('@pages/pages.component').then((c) => c.PagesComponent),
    loadChildren: () => import('@pages/page.routes').then((c) => c.pageRoutes),
  },
  // need to put this between route of '' and :eventDirectory
  // to avoid looping redirect when eventDir not found whether from state or path params
  // because if we put 'not-found' at the last before wildcard, it will match with ':eventDirectory'
  // and then redirect to 'not-found' again
  {
    path: 'not-found',
    data: {
      isNotFound: true,
    },
    loadComponent: () => import('@pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
  },
  {
    path: ':eventDirectory',
    canMatch: [isUnbrandedCanMatch],
    canActivate: [isValidEventGuard],
    loadComponent: () => import('@pages/pages.component').then((c) => c.PagesComponent),
    loadChildren: () => import('@pages/page.routes').then((c) => c.pageRoutes),
  },
  {
    path: '**',
    data: {
      isNotFound: true,
    },
    loadComponent: () => import('@pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
  },
];
